// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { Transform } from 'class-transformer';
import { IsInt, IsOptional, IsString, ValidateNested } from 'class-validator';

class LibraryForm {
  @IsOptional()
  @IsInt()
  id?: number;

  @IsString()
  name: string;
}

export class ImportSymbolForm {
  @ValidateNested()
  library: LibraryForm;

  // Some weird transform here due to class transformer not being able to properly work with File
  @Transform((value) => value.obj.file)
  file: File;
}
